<template>
    <div class="apprentice-simple-card">
        <div class="muted-text description">
            {{ $t('project.select_a_group_to_which_you_want_to_move_the_project') }}
        </div>
        <div v-if="!loaded">
            <b-button
                variant="primary"
                @click="loadGroups"
                >{{ $t('project.collect_groups') }}</b-button
            >
        </div>
        <div v-else>
            <div class="move-group">
                <b-input-group class="migrate-group">
                    <b-form-select
                        class="apprentice-primary-select"
                        v-model="selectedGroupId"
                        :options="groups"
                        text-field="option_name"
                        value-field="id"
                        place></b-form-select>
                    <b-input-group-append>
                        <b-button
                            variant="primary"
                            :disabled="!selectedGroupId"
                            @click="changeGroup"
                            >{{ $t('project.move') }}</b-button
                        >
                    </b-input-group-append>
                </b-input-group>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'design-2021-project-show-teacher-change-group-component',
    props: ['projectIn'],
    data() {
        return {
            selectedGroupId: null,
            loaded: false,
            groups: [],
        };
    },
    methods: {
        loadGroups() {
            if (this.loaded) {
                return;
            }

            this.alert.loading();
            this.axios.get(this.routes.groupTeacherChange(this.projectIn.id)).then(
                (response) => {
                    this.groups = response.data
                        .filter(
                            (group) =>
                                group.id !== this.projectIn.group_id && group.type_id === this.projectIn.group.type_id,
                        )
                        .map((group) => {
                            group.option_name = group.name + ' (' + group.id + ')';
                            return group;
                        });
                    this.groups.unshift({ value: null, option_name: this.$t('project.select_group') });

                    this.loaded = true;
                    this.alert.close();
                },
                (alert) => {
                    this.alert.ajaxError(error);
                },
            );
        },
        changeGroup() {
            this.alert
                .confirm(
                    this.$t('project.move_project'),
                    this.$t(
                        'project.are_you_sure_you_want_to_move_this_project_this_can_cause_loss_of_progress_such_as_evaluation_forms_step_plan_etc',
                    ),
                    this.$t('project.yes_move'),
                )
                .then((confirm) => {
                    if (confirm) {
                        this.alert.saving();
                        this.axios
                            .post(this.routes.projectTeacherChangeGroup(this.projectIn.id, this.selectedGroupId))
                            .then(
                                (response) => {
                                    location.reload();
                                },
                                (error) => {
                                    this.alert.ajaxError(error);
                                },
                            );
                    }
                });
        },
        updateTabIndex(tabIndex) {
            this.activeTab = tabIndex;
            localStorage.adminSettingsTab = tabIndex;
        },
    },
};
</script>

<style scoped lang="scss">
.description {
    margin-bottom: map-get($grid-gutter-spacing, 'twenty-one');
}

.move-group {
    max-width: 500px;
    width: 100%;
}
</style>
